<template>
  <div class="plan-overview">
    <div class="plan-badge">
      <div :class="`plan-${badge.class}`" v-for="badge in badges" :key="badge">
        <img :src="`/assets/irinox/icons/plans/${badge.image}`" :alt="badge.name" />
        <span>{{ badge.name }}</span>
      </div>
    </div>

    <div class="p-d-flex p-flex-column p-jc-between" style="height: 100%;">

      <div class="p-f-flex p-flex-column">

        <div class="plan-title">
          <p>{{ title }}</p>
        </div>
    
        <div class="plan-description">
          <p>{{ description }}</p>
        </div>
    
        <div class="plan-features">
          <div class="plan-feature" v-for="feature in features" :key="feature">
            <i v-if="feature.icon" :class="`pi ${feature.icon}`"></i>
            <span>{{ feature.name }}</span>
          </div>
        </div>
    
        <div class="plan-disclaimer">
          {{ disclaimer }}
        </div>

      </div>


      <div class="plan-footer">
        <div class="plan-button" @click="$emit('click:button')">{{ button }}</div>
      </div>

    </div>
    
  </div>
</template>

<script>
export default {
  emits: ['click:button'],
  components: {
  },
  setup() {
  },
  props: {
    badges: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    features: {
      type: Array,
      default: () => []
    },
    disclaimer: {
      type: String,
      default: ''
    },
    button: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  mounted() {
  },
  methods: {
  },
}
</script>

<style scoped></style>